/** Shared editorial theme preference (html.dark + localStorage). */
export const THEME_STORAGE_KEY = 'jn-editorial-dark';

export function readStoredDark(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    const v = window.localStorage.getItem(THEME_STORAGE_KEY);
    if (v === '1') return true;
    if (v === '0') return false;
  } catch {
    /* private mode */
  }
  return document.documentElement.classList.contains('dark');
}

export function applyTheme(dark: boolean): void {
  document.documentElement.classList.toggle('dark', dark);
  try {
    window.localStorage.setItem(THEME_STORAGE_KEY, dark ? '1' : '0');
  } catch {
    /* ignore */
  }
}
